import { withStyles } from 'tss-react/mui';
import Button from '@mui/material/Button';

const ThemedButton = withStyles(Button, (theme) => ({
  root: {
    height: '32px',
    lineHeight: 1,
    textTransform: 'capitalize',
  },
  outlined: {
    backgroundColor: theme.palette.white,
  },
  outlinedPrimary: {
    borderColor: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.white,
    },
  },
}));

export default ThemedButton;
